import { Component, effect, inject } from "@angular/core";
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from "@angular/forms";
import { CardModalService } from "@shared/card-modal";
import { SharedModule } from "@shared/shared.module";
import { DeliveryMethodsService, IFirmDeliveryMethodsService, type IiFirmDeliveryMethod, HelpersService } from "@shared/index";
import { IDashboardModel, TranslateObject } from "@app/views-interfaces";
import { TranslateModule } from "@ngx-translate/core";
import { KENDO_TOOLTIPS } from "@progress/kendo-angular-tooltip";

@Component({
    selector: "wk-delivery-methods-panel",
    imports: [KENDO_TOOLTIPS, SharedModule, TranslateModule, ReactiveFormsModule],
    templateUrl: "./delivery-methods-panel.component.html",
    styleUrl: "./delivery-methods-panel.component.scss",
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class DeliveryMethodsPanelComponent {
    public readonly cardModalService = inject(CardModalService);
    private readonly deliveryMethodsService = inject(DeliveryMethodsService);
    private readonly iFirmDeliveryMethodsService = inject(IFirmDeliveryMethodsService);
    public readonly helpersService = inject(HelpersService);

    constructor() {
        effect(() => {
            this.init(this.cardModalService.currentDashboard(), this.cardModalService.isiFirmTaxDashboard());
        });
    }

    async init(currentDashboard: IDashboardModel | null, isiFirmTaxDashboard: boolean) {
        if (currentDashboard) {
            let deliveryMethods: { key: number; value: TranslateObject }[] | IiFirmDeliveryMethod[];

            if (isiFirmTaxDashboard && currentDashboard.TaxYear >= 2025) {
                deliveryMethods = await this.iFirmDeliveryMethodsService.getiFirmDeliveryMethods();
                this.cardModalService.isiFirmDeliveryMethods.set(true);
            } else {
                this.cardModalService.isiFirmDeliveryMethods.set(false);
                const deliveryMethodsList = this.deliveryMethodsService.getDeliveryMethodsList(currentDashboard);
                deliveryMethods = Object.keys(deliveryMethodsList).map((key) => ({
                    key: Number(key),
                    value: deliveryMethodsList[key],
                }));
            }

            this.cardModalService.deliveryMethods.set(deliveryMethods);
        }
    }
}
